import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttributeTypeDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class AttributeTypesService {
  constructor(private httpService: HttpService) {}

  public getAttributeTypes(filterData: object): Observable<AttributeTypeDto> {
    return this.httpService.postHttp<AttributeTypeDto>(
      Constants.ServiceConstants.ATTRIBUTES_TYPES,
      filterData
    );
  }
}
